import {
  processingItemsService,
  setProcessingItems,
  fetchProcessingHomes,
  setProcessingHomes,
  appNotify,
  setProcessingHomesIsLoading
} from '../store/actions';
import { getWithToken } from 'api/network';
import { takeLatest, put, select } from 'redux-saga/effects';
import { processingItemsServiceStatusSelector } from 'store/selectors';
import { sendClientLog } from 'services/logService';

export function* getProcessingItemsSaga() {
  yield takeLatest(processingItemsService, function* () {
    try {
      const oldState = yield select(processingItemsServiceStatusSelector);
      yield put(setProcessingItems({ ...oldState, loading: true }));
      const response = yield getWithToken(`/api/admin/processing_items`);
      const data = yield response.json();

      yield put(setProcessingItems({ timestamp: Date.now(), loading: false, data }));
    } catch (error) {
      sendClientLog('Info', 'User checked Processing Items. Failed retrieving the information.');
      yield put(setProcessingItems({ timestamp: Date.now(), loading: false, data: [] }));
      yield put(appNotify(error.message, 'error'));
    }
  });
  yield takeLatest(fetchProcessingHomes, function* () {
    try {
      yield put(setProcessingHomesIsLoading(true));
      const response = yield getWithToken(`/api/admin/processingOpportunities`);
      const data = yield response.json();

      yield put(setProcessingHomes(data.data));
    } catch (error) {
      sendClientLog('Info', 'User checked Processing Opportunities. Failed retrieving the information.');
      yield put(appNotify(error.message, 'error'));
    } finally {
      yield put(setProcessingHomesIsLoading(false));
    }
  });
}